module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av20-e87dfb14f156997a95a89fde0be134bd.jpg";